import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { FeatureWalk } from './index';
import '~/styles/main.scss';

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;

global.FeatureWalk = FeatureWalk;
// CLR alias: PortableComponent.cshtml renders FeatureWalkGroup blocks via this component.
global.FeatureWalkGroup = FeatureWalk;
